export const PM_DASHBOARD_USER_IDS = [3, 47, 10, 36, 105];

export const canAccessPmDashboard = (user) => PM_DASHBOARD_USER_IDS.includes(user?.id);
